import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

export default function OrderHeader() {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth < 768
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () =>
      window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <header
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: isMobile ? "16px 20px" : "20px 48px",
        borderBottom: "1px solid rgba(26,22,17,0.12)",
        position: "sticky",
        top: 0,
        zIndex: 50,
      }}
    >
      <Link
        to="/"
        style={{
          fontSize: isMobile ? "0.6rem" : "0.72rem",
          letterSpacing: isMobile ? "0.08em" : "0.14em",
          textTransform: "uppercase",
          color: "#000",
          textDecoration: "none",
          display: "flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        ← Back to site
      </Link>

      <span
        style={{
          fontSize: isMobile ? "0.55rem" : "0.72rem",
          letterSpacing: isMobile ? "0.1em" : "0.18em",
          textTransform: "uppercase",
          color: "#000",
          textAlign: "center",
        }}
      >
        Book Order — Decolonizing Mission
      </span>
    </header>
  );
}